(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var productBar;
  var productButtonObserver;
  var cartObserver;
  var scheduled = false;

  function isVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function textOf(element) {
    return (element && (element.innerText || element.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function toolbarHeight() {
    var toolbar = document.querySelector('.halo-sticky-toolbar-mobile');
    if (!toolbar || !isVisible(toolbar)) return 0;
    return Math.round(toolbar.getBoundingClientRect().height || 0);
  }

  function activeStickyHeight() {
    var sticky = document.querySelector('.divideute-mobile-sticky-action:not([hidden]), .cart-actions.divideute-cart-sticky-checkout');
    if (!sticky || !mobileQuery.matches || !isVisible(sticky)) return 0;
    return Math.round(sticky.getBoundingClientRect().height || 0);
  }

  function updateOffsets() {
    document.documentElement.style.setProperty('--divideute-mobile-toolbar-height', toolbarHeight() + 'px');
    var height = activeStickyHeight();
    document.documentElement.style.setProperty('--divideute-mobile-sticky-height', height + 'px');
    document.body.classList.toggle('divideute-has-mobile-sticky-action', mobileQuery.matches && height > 0);
  }

  function getMainAddButton() {
    return document.querySelector('main #product-add-to-cart') ||
      document.querySelector('main form[action*="/cart/add"] button[name="add"]') ||
      document.querySelector('main button[name="add"][data-btn-addToCart]');
  }

  function isMainAddButtonComfortablyVisible(button) {
    if (!isVisible(button)) return false;
    var rect = button.getBoundingClientRect();
    var reservedBottom = toolbarHeight() + 16;
    return rect.top >= 0 && rect.bottom <= (window.innerHeight - reservedBottom);
  }

  function ensureProductBar() {
    if (productBar) return productBar;

    productBar = document.createElement('div');
    productBar.className = 'divideute-mobile-sticky-action divideute-mobile-sticky-action--product';
    productBar.hidden = true;
    productBar.setAttribute('aria-live', 'polite');
    productBar.innerHTML = '<div class="divideute-mobile-sticky-action__meta"><span class="divideute-mobile-sticky-action__eyebrow">Ready to order</span><strong class="divideute-mobile-sticky-action__title"></strong></div><button type="button" class="divideute-mobile-sticky-action__button">Buy Now</button>';
    document.body.appendChild(productBar);

    productBar.querySelector('button').addEventListener('click', function () {
      var mainButton = getMainAddButton();
      if (!mainButton) return;

      if (mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') {
        mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      mainButton.click();
    });

    return productBar;
  }

  function observeProductButton(button) {
    if (!button || (productButtonObserver && productButtonObserver.target === button)) return;
    if (productButtonObserver) productButtonObserver.disconnect();

    productButtonObserver = new MutationObserver(scheduleUpdate);
    productButtonObserver.target = button;
    productButtonObserver.observe(button, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function updateProductStickyAction() {
    if (!document.body.classList.contains('template-product')) return;

    var mainButton = getMainAddButton();
    if (!mainButton) {
      if (productBar) productBar.hidden = true;
      updateOffsets();
      return;
    }

    var bar = ensureProductBar();
    var stickyButton = bar.querySelector('button');
    var title = bar.querySelector('.divideute-mobile-sticky-action__title');
    var productTitle = textOf(document.querySelector('main h1')) || 'DivideUte';
    var buttonText = textOf(mainButton) || 'Buy Now';
    var disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';

    title.textContent = productTitle;
    stickyButton.textContent = disabled ? 'Choose Options' : buttonText;
    stickyButton.disabled = disabled;
    bar.hidden = !mobileQuery.matches || isMainAddButtonComfortablyVisible(mainButton);

    observeProductButton(mainButton);
    updateOffsets();
  }

  function getCartTotalText() {
    var total = document.querySelector('.cart-totals .cart-total-grandtotal .cart-total-value .text') ||
      document.querySelector('.cart-total-grandtotal .cart-total-value .text');
    return textOf(total);
  }

  function updateCartStickyAction() {
    if (!document.body.classList.contains('template-cart')) return;

    var checkoutButton = document.getElementById('cart-checkout');
    if (!checkoutButton) {
      document.body.classList.remove('divideute-has-mobile-sticky-action');
      updateOffsets();
      return;
    }

    var actions = checkoutButton.closest('.cart-actions');
    if (!actions) return;

    actions.classList.add('divideute-cart-sticky-checkout');

    var totalRow = actions.querySelector('.divideute-cart-sticky-total');
    if (!totalRow) {
      totalRow = document.createElement('div');
      totalRow.className = 'divideute-cart-sticky-total';
      totalRow.innerHTML = '<span>Total</span><strong></strong>';
      actions.insertBefore(totalRow, actions.firstChild);
    }

    totalRow.querySelector('strong').textContent = getCartTotalText();
    updateOffsets();

    var cartRoot = document.getElementById('main-cart-items');
    if (cartRoot && !cartObserver) {
      cartObserver = new MutationObserver(scheduleUpdate);
      cartObserver.observe(cartRoot, { childList: true, subtree: true });
    }
  }

  function updateStickyActions() {
    scheduled = false;
    updateProductStickyAction();
    updateCartStickyAction();
    updateOffsets();
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateStickyActions);
  }

  document.addEventListener('DOMContentLoaded', scheduleUpdate);
  document.addEventListener('change', scheduleUpdate);
  document.addEventListener('click', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('scroll', scheduleUpdate, { passive: true });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', scheduleUpdate);
  }

  scheduleUpdate();
})();
